export default __webpack_public_path__ + "static/media/cnpq.6eac7475.png";